export enum CustumActionMessage {
    ApplicationSubscription = "Application Subscription",
    DeploymentInProgress = "Version Mismatch - PowerLine Deployment",
    ManifestIsPublishing = "Manifest is Publishing",
    UpdateApp = "Version Mismatch - Update App"
}